import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ScrollFunctions } from '../util/ScrollFunctions';
import { AvantoModalControlService } from './avanto-modalControl.service';

@Injectable({
  providedIn: 'root'
})
export class AvantoRoutingService {

  constructor(private router: Router, private modal:AvantoModalControlService) {}

  goToBasePage(){
    ScrollFunctions.scrollToTop();//TODO: I DONT THINK THIS WORKS...
    this.router.navigate([""]);
  }

  goToChooseRestaurantPage(){
    ScrollFunctions.scrollToTop();
    this.router.navigate([""]);
  }
  
  goToInitialPage(){
    ScrollFunctions.scrollToTop();
    //TODO: Checks the session for a zip code. If it doesn't exist, go to the front page. If it does, go to the choose restaurant screen.
    // this.goToBasePage()
    this.goToChooseRestaurantPage();
  }

  goToOneRestaurantModeChooseFoodPage(locationId:string,restaurantId:string){
    ScrollFunctions.scrollToTop();
    this.router.navigate(["/menu/"+locationId+"/"+restaurantId]);
  }

  goToChooseFoodPage(locationId:string,restaurantId:string){
    ScrollFunctions.scrollToTop();
    this.router.navigate(["/menu/"+locationId+"/"+restaurantId]);
  }

  goToCustomerDashboardPage(){
    ScrollFunctions.scrollToTop();
    this.router.navigate(["/customer/dashboard"]);
  }

  goToCheckoutPage(){
    ScrollFunctions.scrollToTop();
    //This is already the checkout page
    if(this.router.url == '/checkout'){
      this.modal.closeCartModal();
    }else{
      this.router.navigate(["/checkout"]);
    }
  }

  goToSquareCheckoutPage(isContactlessDelivery){
    if(isContactlessDelivery){
      this.router.navigate(["/square/checkout/contactless"])
    }else{
      this.router.navigate(["/square/checkout/default"])
    }
  }

  goToOrderCompletePage(type?:string){
    ScrollFunctions.scrollToTop();
    if(type==null || type == ""){
      type = "success";
    }
    this.router.navigate(["/checkout/"+type]);
  }

  //=== Authentication ===\\
  goToCustomerLoginPage(){
    ScrollFunctions.scrollToTop();
    this.router.navigate(["/customer/authentication/signIn"]);
  }
  goToCustomerLoginPageThenReturnToCheckout(){
    ScrollFunctions.scrollToTop();
    this.router.navigate(["/customer/authentication/signInCheckout"]);
  }
  goToCustomerSignUpPage(){
    ScrollFunctions.scrollToTop();
    this.router.navigate(["/customer/authentication/signUp"]);
  }
  goToCustomerSignUpPageThenReturnToCheckout(){
    ScrollFunctions.scrollToTop();
    this.router.navigate(["/customer/authentication/signUpCheckout"]);
  }
}

import Swal from 'sweetalert2';
export function goToThirdPartyDeliveryWebsite(thirdPartyDeliverySite){
  Swal.fire({
    title: 'To make a delivery order, you will be redirected to another website',
    showCancelButton: true,
    confirmButtonText: 'Continue',
  }).then((result) => {
    if(result.value){
      //The following redirects the customer to a third party website
      window.location.href=thirdPartyDeliverySite;
    }
  })
}
